// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"AreasSection_sectionWrapper__SBSr8","introductionWrapper":"AreasSection_introductionWrapper__jwbSO"};